import exifJS from 'exif-js';

const exif = url => ({
  /**
   * Async function returns { data, error }
   */
  getDate() {
    return new Promise(resolve => {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        exifJS.getData(image, () => {
          const data = exifJS.getTag(image, 'DateTimeOriginal');
          if (data) {
            resolve({ data: data.replace(/\0/g, '') });
          } else {
            resolve({ error: 'No datetime in exif' });
          }
        });
      };
      image.onerror = () => {
        resolve({ error: 'Image not found' });
      };
    });
  },
});

export default exif;
